const generateSummaryStep = (amtProducts:number, hideGlass:boolean, glassIsMandatory:boolean) => {

  const prodList = [...Array(amtProducts)].map((_, index) => {
    return `
      <div class="product-item bottle-item">
        <span class="item-content">
          <div><span class="step-number">${index + 1}</span></div>
          <h4 class="product-title"></h4>
          <p class="info"></p>
        </span>
        <button class="edit-button" step-index="${index}">Edit</button>
      </div>
    `
  }).join('');

  const addGlass = glassIsMandatory ? `
    <div class="product-item glass-item glass-is-mandatory glass-is-added">
      <span class="item-content">
        <span class="glass-included-icon"></span>
        <h4 class="product-title">Glass Included</h4>
        <p class="info"></p>
      </span>
    </div>
  ` : `
    <button class="product-item glass-item" step-index="${amtProducts}">
      <span class="item-content">
        <span class="add-glass-btn"></span>
        <h4 class="product-title">Add a glass</h4>
        <p class="info">For $100</p>
      </span>
    </button>
  `

  return `
  <style>
    * {

      box-sizing: border-box;
    }

    .bundle-summary {
      height: 100%;
      display: none;
    }

    .bundle-summary.active {
      display: block;
    }


    .title,
    .message-heading {
      font-size: 1.25rem;
      font-weight: 485;
      line-height: 1.625rem;
      letter-spacing: 0.025rem;
      text-transform: uppercase;
      margin-top: 2.4375rem;
      margin-bottom: 1.75rem;
    }

    .summary-body {
      height: 90%;
      overflow-y: auto;
    }

    .product-summary {
      margin: 0 2.5rem;
    }

    .product-item {
      border-top: 0.0625rem solid var(--transparent-navy-navy-12);
      padding: 1.5rem 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      background: transparent;
    }

    .product-item:last-child {
      border-bottom: 0.0625rem solid var(--transparent-navy-navy-12);
    }

    .bottle-item {}

    .glass-item {
      border-left: none;
      border-right: none;
    }
    
    .glass-item.glass-is-added {}

    .item-content,
    .edit-button {
      display: flex;
      align-items: center;

      font-family: var(--font-secondary);
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1rem;
      letter-spacing: 0.135rem;
      text-transform: uppercase;
    }

    .glass-item.glass-is-added .add-glass-btn::after {
      display: none;
    }

    .glass-item.glass-is-mandatory {
      cursor: default;
    }

    .glass-included-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.875rem;
      border: 0.0625rem solid var(--transparent-navy-navy-12);
      border-radius: 50%;
      height: 2.25rem;
      width: 2.25rem;
      background-color: var(--opaque-lark-navy);
    }

    .glass-included-icon::before {
      content: '';
      width: 0.625rem;
      height: 0.375rem;
      border-left: 0.125rem solid white;
      border-bottom: 0.125rem solid white;
      transform: rotate(-45deg);
      margin-bottom: 0.125rem;
    }

    .add-glass-btn, .step-number {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.875rem;
      border: 0.0625rem solid var(--transparent-navy-navy-12);
      border-radius: 50%;
      height: 2.25rem;
      width: 2.25rem;
      position: relative;
      padding-left: 0.0625rem;
    }

    .add-glass-btn::before, .add-glass-btn::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .glass-is-added .add-glass-btn::before {
      background-color: var(--opaque-lark-navy);
      width: 0.625rem;
      height: 0.0625rem;
    }

    .add-glass-btn::after { 
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3E%3Cpath stroke='%23123247' stroke-linecap='square' stroke-linejoin='round' d='M8 3.333v9.334M3.333 8h9.334'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      width: 0.75rem;
      height: 0.75rem;
    }

    .product-title, .title {
      color: var(--opaque-lark-navy);
      font-weight: 400;
    } 

    .product-title {
      text-align: left;
      margin: 0;
    }

    .info { 
      color: var(--transparent-navy-navy-40);
      margin: 0 0.75rem;
    }

    .edit-button {
      background-color: transparent;
      border: none;
      text-decoration-line: underline;
      text-decoration-color: var(--transparent-gray);
      text-decoration-thickness: 0.0625rem;
      text-underline-offset: 0.5rem;
    }

    .message-wrapper {
      display: none;
      margin: 0 2.5rem;
    }

    .message-wrapper textarea::placeholder {
      color: var(--transparent-navy-navy-40);
      font-family: var(--font-secondary);
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1rem;
      letter-spacing: 0.135rem;
      text-transform: uppercase;
    }

    .message-text {
      border-radius: 0.875rem;
      background: rgba(18, 50, 71, 0.04);
      max-width: 27.5rem;
      width: 100%;
      height: 3rem;
      border: none;
      padding: 1rem;
    }

    .atc-button {
      border-radius: 2.5rem;
      border: none;
      background-color: var(--opaque-lark-navy);
      color: var(--color-white);
      cursor: pointer;
      font-family: var(--font-secondary);
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1rem; 
      letter-spacing: 0.135rem;
      padding: 0.625rem 1.5rem;
      margin-top: 2rem;
      margin-bottom: 1.8125rem;
      text-transform: uppercase;
    }

    @media screen and (max-width: 991px) {
      .product-summary,
      .message-wrapper {
        margin: 0;
      }

      .message-heading {
        margin: 2.5rem 0 1.25rem;
      }

      .title {  
        margin-top: 0;
      }

      .info { 
        margin: 0 0.625rem;
      }
      
      .atc-button {
        margin-bottom: 0;
      }

    }

  </style>
  <div class="bundle-summary" part="summary">
    <h2 class="title">Personalise</h2>
    <div class="summary-body">
      <div class="product-summary">
        ${ prodList }
        ${ !hideGlass ? addGlass : ''}
      </div>

      <div class="message-wrapper">
        <h3 class="message-heading">Add your custom message</h3>
        <textarea class="message-text" rows="10" placeholder="YOUR MESSAGE (optional)"></textarea>
      </div>

      <button class="atc-button"></button>
    </div>
  </div>
`;
}

type ProductItem = {
  product: HTMLElement;
  title: HTMLElement;
  info: HTMLElement;
  addBtn?:HTMLElement;
}
export class BundleSummary extends HTMLElement {

  private readonly root:HTMLDivElement|null;
  private readonly atcButton:HTMLButtonElement;
  private readonly bottleItems:ProductItem[] = [];
  private readonly glassItem:ProductItem;
  public readonly noteElement:HTMLInputElement;

  private readonly glassPrice:string = this.getAttribute('glass-price') || '';
  private readonly hideGlassProduct:boolean = this.getAttribute('hide-glass-product') === 'true';
  private readonly glassIsMandatory:boolean = this.getAttribute('glass-is-mandatory') === 'true';
  private readonly amtProducts:number = parseInt(this.getAttribute('amount-products') || '');

  private stepIsActive:boolean = false;

  constructor() {
    super();

    const template = document.createElement('template');
    template.innerHTML = generateSummaryStep(this.amtProducts, this.hideGlassProduct, this.glassIsMandatory);

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));


    this.root = shadowRoot.querySelector('.bundle-summary')!;
    this.atcButton = shadowRoot.querySelector('.atc-button')!;
    this.noteElement = shadowRoot.querySelector('.message-text')!;

    this.atcButton.addEventListener('click', this.handleAtcClick);

    this.bottleItems = [...shadowRoot.querySelectorAll('.bottle-item')].map(bottleItem => {
      const editBtn = bottleItem.querySelector('.edit-button')!;
      const title = bottleItem.querySelector('.product-title')!;
      const info = bottleItem.querySelector('.info')!;
      editBtn.addEventListener('click', this.handleEditClick);

      return {
        product: bottleItem as HTMLElement,
        title: title as HTMLElement,
        info: info as HTMLElement
      }
    });

    if (!this.hideGlassProduct) {
      const glassItem = shadowRoot.querySelector('.glass-item')!;
      // Only add click handler if glass is not mandatory
      if (!this.glassIsMandatory) {
        glassItem.addEventListener('click', this.handleGlassClick);
      }
      this.glassItem = {
        product: glassItem as HTMLElement,
        info: glassItem.querySelector('.info') as HTMLElement,
        title: glassItem.querySelector('.product-title') as HTMLElement
      }
    }
  }

  private handleAtcClick() {
    const event = new CustomEvent('add_to_cart', { 
      detail: {}, 
      bubbles: true, 
      composed: true 
    });

    this.dispatchEvent(event);
  }

  public setProducts(bundleProducts) {
    this.bottleItems.forEach((item, index) => {
      if (!item) return console.warn('No product set. Cannot apply update to Summary Page');
      const productAtIndex = bundleProducts[index];
      const newTitle = productAtIndex?.product_title ?? '';
      const newInfo = productAtIndex?.title ?? '';

      const { title, info } = item;

      title.textContent = newTitle;
      info.textContent = newInfo;
    });

  }

  private handleGlassClick() {
    const event = new CustomEvent('glass_select', { 
      detail: {}, 
      bubbles: true, 
      composed: true 
    });

    this.dispatchEvent(event);
  }

  private handleEditClick() {

    const stepIndex = parseInt(this.getAttribute('step-index') || '0');
    const event = new CustomEvent('navigation', { 
      detail: { stepIndex }, 
      bubbles: true, 
      composed: true 
    });

    this.dispatchEvent(event);
  }

  public updateGlass(addGlass:boolean) {

    if (this.hideGlassProduct) return console.warn('Glass cannot be selected!');
    
    // Skip UI updates for mandatory glass - it's always shown as included
    if (this.glassIsMandatory) return;

    const { product, info, title } = this.glassItem;

    product.classList[addGlass ? 'add' : 'remove']('glass-is-added');

    const newTitle = addGlass ? 'Remove the Glass' : 'Add a Glass'
    const newInfo = addGlass ? '' : `For ${this.glassPrice}`

    title.textContent = newTitle;
    info.textContent = newInfo;

  }

  public setAddToCartText(amount:number) {
    this.atcButton.textContent = `Add to cart - $${amount}`;
  }

  setNote(noteText:string) {
    this.noteElement.value = noteText;
  }

  setActive(isActive:boolean) {
    this.stepIsActive = isActive;
    this.root?.classList[this.stepIsActive ? 'add' : 'remove']('active')
  }
}

if(!customElements.get('bundle-summary')) {
  customElements.define('bundle-summary', BundleSummary);
}